// extracted by mini-css-extract-plugin
export var active = "_e8-7";
export var container = "_e8-0";
export var evenWidth = "_e8-4";
export var large = "_e8-5";
export var outlet = "_e8-8";
export var slide = "_e8-2";
export var small = "_e8-6";
export var tab = "_e8-3";
export var tabs = "_e8-1";